<template>
	<div class="center">
		<div class="profile-box">
			<div class="left">
				<div class="profile">
					<img class="avatar" :src="avatar" />
					<div class="mail-phone">
						<div class="phone">{{ profile.nickname }}</div>
						<div class="mail">注册时间：{{ profile.create_time }}</div>
					</div>
					<router-link class="edit" to="/user/profile">
						<span >个人信息</span>
						<img src="../../assets/images/user/edit@2x.png" />
					</router-link>
				</div>

			</div>
			<div class="right">

				<router-link class="point" to="/user/pointlog">
					<div class="total">{{ account.point }}</div>
					<div style="color: #0F114A;">积分</div>
				</router-link>

				<div class="money">
					<div class="total">{{ account.money }}</div>
					<div>余额</div>
					<router-link class="logs" to="/user/statement">余额明细</router-link>
				</div>
				<router-link class="coupon"  to="/user/coupon">
					<div class="total">{{ account.coupon_num }}</div>
					<div style="color: #0F114A;">优惠券</div>
				</router-link>

			</div>
		</div>
		<div class="order-count">
			<div>
				<span>待支付</span>
				<span class="value">{{ orderCount.unpaid }}</span>
			</div>
			<div>
				<span>待收货</span>
				<span class="value">{{ orderCount.waiting_confirm }}</span>
			</div>
			<div>
				<span>已完成</span>
				<span class="value">{{ orderCount.complete }}</span>
			</div>
		</div>
		<div class="order-list">
			<div class="order-search">
				<div class="title">我的订单</div>
				<div class="search-box">
					<input placeholder="输入订单号搜索" v-model="keyword"  />
					<div class="search" @click="search">搜索</div>
				</div>
			</div>
			<div class="order-tab">
				<Tabs :tabs="tabs" :cur="curIndex" @changeTab="changeTab"></Tabs>
				<div class="btn-union" v-show="curIndex===1" @click="unionPay" >{{ isEditUnionPay ? '确认支付' : '合并支付' }}</div>
			</div>
			<div class="orders" v-if="orderList.length > 0">
				<OrderItem  v-for="(item,index) in orderList" :item="item" :key="index" @checkedItem="checkedItem" :index="index" :isEdit="isEditUnionPay" v-on:refresh="refresh"></OrderItem>
				<Page :current="page" :page-size="size"  :total="total" @on-change="changePage" show-total style="margin-top: 20px;"  show-sizer @on-page-size-change="changeSize" :page-size-opts="[5, 10, 20]"></Page>
			</div>
			<div v-else>
				<NoOrder></NoOrder>
			</div>

		</div>
	</div>

</template>

<script>
	import axios from 'axios'
	import {
		profile,
		accountGeneral,
		getOrderList,
		getOrderCount
	} from "@/api/index.js"
	import Tabs  from "@/components/Tabs.vue";
	import OrderItem  from "@/components/OrderItem.vue";
	import NoOrder from "@/components/NoOrder.vue"
	export default {
		name: 'Center',
		components: {
			Tabs,
			OrderItem,
			NoOrder
		},
		data() {
			return {
				isEditUnionPay: false,
				page:  1,
				total: -1,
				size:3,
				tabs:[
					{
						index:0,
						title:'全部订单',
						value:'all'
					},
					{
						index:1,
						title:'待付款',
						value:'unpaid'
					},
					{
						index:2,
						title:'生产中',
						value:'in_pperation'
					},
					{
						index:3,
						title:'待发货',
						value:'waiting_delivery'
					},
					{
						index:4,
						title:'待收货',
						value:'waiting_confirm'
					},
					{
						index:5,
						title:'待评价',
						value:'complete'
					},
				],
				curIndex:0,
				orderStatus:"all",
				orderList:[

				],
				profile: {
					real_name: "",
					nickname: "",
					avatar: "",
				},
				account: {
					balance: 0,
					credit: 0,
					point: 0,
					coupon_num:0
				},
				keyword:'',
				orderCount:{
					unpaid:0,
					waiting_confirm:0,
					complete:0
				}
			};
		},
		computed: {
			avatar() {
				return this.profile.avatar || require('@/assets/images/avatar.png')
			}
		},
		mounted() {
			axios.all([
				profile(),
				accountGeneral(),
				getOrderCount()
			]).then(axios.spread((response1, response2, response3) => {
				console.log(response1)
				this.profile = response1.data
				this.$store.commit('setUserInfo',response1.data)
				this.account = response2.data
				this.orderCount = response3.data
			}))
			this.getList()
		},
		methods: {
			checkedItem(e) {
				this.orderList[e.index].isChecked = e.isChecked
			},
			unionPay() {
				if (this.isEditUnionPay) {
					let list = this.orderList.filter(i => i.isChecked)
					if (list.length == 0) {
						return
					}
					let order_ids = list.map(i => i.order_id)
					this.$router.push({
						name: 'Paytype',
						query: {id:order_ids.join(',')}
					})
					return
				}
				this.isEditUnionPay = !this.isEditUnionPay

			},
			refresh() {
				this.getList()
			},
			changePage(page) {
				this.page = page
				this.getList()
			},
			changeSize(size) {
				this.page = 1
				this.size = size
				this.getList()
			},
			changeTab(index) {
				this.curIndex = index
				this.orderStatus = this.tabs[index].value
				this.getList()
			},
			async getList() {
				let json =  await getOrderList({page: this.page, size: this.size, status: this.orderStatus, keyword: this.keyword})
				this.orderList = json.data.list
				this.total = json.data.count
			},
			search() {
				this.getList()
			}
		},

	}
</script>

<style lang="scss" scoped>
	.profile-box{
		height: 179px;
		background: #FFFFFF;
		display: flex;
		padding: 20px;
		.left {
			width: 45%;
			height: 139px;
			border-right: 1px dotted #EEEEEE;
			padding: 10px;
			.profile{
				display: flex;
				.avatar{
					width: 76px;
					height: 76px;
					border-radius: 50%;
				}
				.mail-phone{
					margin-left: 20px;
					.phone {
						font-size: 20px;
						font-family: PingFang SC;
						font-weight: bold;
						color: #333333;
						margin-top: 10px;
					}
					.mail{
						font-size: 15px;
						font-family: PingFang SC;
						font-weight: 400;
						color: #666666;
						margin-top: 10px;
					}
				}
				.edit{
					display: flex;
					align-items: center;
					height: 15px;
					color: #0F114A;
					img{
						width: 12px;
						height: 12px;
						margin-left: 5px;
					}
				}
			}
			.date{
				font-size: 14px;
				font-family: PingFang SC;
				font-weight: 400;
				color: #666666;
				margin-top: 10px;
			}
		}
		.right {
			width: 55%;
			height: 139px;
			font-size: 13px;
			font-weight: 400;
			text-align: center;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.point{
				position: relative;
				width: 33%;
				border-right: 1px dotted #EEEEEE;
			}
			.money{
				position: relative;
				width: 33%;
				border-right: 1px dotted #EEEEEE;
			}
			.coupon{
				position: relative;
				width: 33%;
			}
			.total{
				font-size: 32px;
				font-weight: bold;
				line-height: 45px;
				color: #0F114A;
				text-align: center;
				margin-top: 45px;
				margin-bottom: 5px;
			}
			.logs{
				position: absolute;
				top: 10px;
				right: 20px;
				font-size: 13px;
				font-weight: 400;
				line-height: 18px;
				color: #0F114A;
			}

		}
	}
	.order-count{
		height: 60px;
		background: #FFFFFF;
		display: flex;
		justify-content: space-around;
		align-items: center;
		margin: 10px 0;
		div{
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #333333;
			display: flex;
			align-items: center;
		}
		.value{
			margin-left: 20px;
			font-size: 20px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #0F114A;
		}
	}
	.order-list{
		background: #FFFFFF;
		padding-bottom: 10px;
		.order-search{
			height: 54px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;
			.title{
				font-size: 17px;
				color: #0F114A;
				font-weight: bold;
			}
			.search-box{
				width: 300px;
				height: 34px;
				border: 1px solid #B3B3B3;
				display: flex;
				align-items: center;
				input{
					width: 240px;
					height: 30px;
					border: none;
					padding-left: 10px;

				}
				.search{
					border-left: 1px solid #B3B3B3;
					width: 60px;
					line-height: 34px;
					height: 34px;
					font-size: 15px;
					font-weight: 400;
					color: #676767;
					text-align: center;
					cursor: pointer;
				}
			}
		}
		.orders{
			margin-top: 20px;
			width: 100%;
			padding: 0 20px;
		}
	}
	.order-tab{
		padding: 0 20px;
		position: relative;
	}


	.btn-union {
		position: absolute;
		top: 10px;
		right: 50px;
		width: 80px;
		height: 30px;
		line-height: 30px;
		background: #0F114A;
		border-radius: 0.15625vw;
		text-align: center;
		color: #EDD4AC;
		cursor: pointer;
	}
</style>
